import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { CommentType } from '../../models/commenttype.enum';
import { Direction } from '../../models/direction.enum';
import { TrackAuthority } from '../../models/trackauthority';
import { Comment } from '../../models/comment';

@Component({
  selector: 'detail-request-authority',
  templateUrl: './detail-request-authority.component.html',
  styleUrls: ['./detail-request-authority.component.scss']
})
export class DetailRequestAuthorityComponent implements OnInit {
  @Input() authorityData: TrackAuthority;
  @Output() availableAuthorities: EventEmitter<void> = new EventEmitter();
  Direction = Direction;
  line11Items: Array<Comment> = new Array<Comment>();
  commentList: Array<Comment> = new Array<Comment>();
  isMobile = window.innerWidth < 700;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = event.target.innerWidth < 700;
  }

  ngOnInit() {
    this.getLine11Items();
    this.getCommentList();
  }

  getLine11Items() {
    this.line11Items = this.authorityData.comments.filter(comment => UtilService.isCommentOfType(comment, [CommentType.LINE11]));
  }

  getCommentList() {
    this.commentList = UtilService.getFirstCommentOfTypes(this.authorityData.comments, [CommentType.PRIVATE]);
  }

  showAuthorities(): void {
    this.availableAuthorities.emit();
  }
}
